/**
 * Базовые адреса бэкендов.
 *
 * Переменная задана — берём её (так живёт прод). Пусто — идём на свой же origin,
 * и запрос проксирует nginx (прод-сборка) или setupProxy.js (npm start). Благодаря
 * этому смена домена не требует пересборки бандла.
 */
const base = (value, sameOrigin) => (value && value.trim()) || sameOrigin;

export const ENDPOINTS = {
  asr: base(process.env.REACT_APP_ASR_API_URL, '/asr-api'),
  asrParakeet: base(process.env.REACT_APP_ASR_API_URL_PARAKEET, '/parakeet-api'),
  diarize: base(process.env.REACT_APP_ASR_API_URL_DIAR_V3, '/diarize-api'),
  dual: base(process.env.REACT_APP_DUAL_CHANNEL_V3_API_URL, '/dual-api'),
  fetch: base(process.env.REACT_APP_FETCH_API_URL, '/fetch-api'),
  auth: base(process.env.REACT_APP_AUTH_API_URL, '/auth-api'),
  // 🔴 Запасной путь включает /api/v1. В ENV_prod переменная кончается на /api/v1
  // (`https://bit-summarize.1bitai.ru/api/v1`), а сервисы фронта дописывают к ней
  // только `/tasks` и `/chat`. Без суффикса запрос уходил в `/summarize-api/tasks`,
  // nginx срезал префикс, и сервис отвечал 404 — саммаризация «не работала».
  // Найдено 04.09.2026 на стенде: на проде переменная задана, и запасная ветка
  // никогда не срабатывала. Та же порода, что у streaming ниже.
  summarize: base(process.env.REACT_APP_SUMMARIZE_API_URL, '/summarize-api/api/v1'),
  // Запасной путь включает /v1/ws: streamingClient.js открывает WebSocket по
  // этому адресу без дописывания пути, а nginx/setupProxy.js матчат только
  // префикс /streaming-api/ (со слешем) — /v1/ws снимается rewrite'ом на бэкенде.
  streaming: base(process.env.REACT_APP_STREAMING_API_URL, '/streaming-api/v1/ws'),
  metrics: base(process.env.REACT_APP_METRICS_API_URL, '/metrics-api'),
  billing: base(process.env.REACT_APP_BILLING_API_URL, '/billing-api'),
  tts: base(process.env.REACT_APP_TTS_API_URL, '/tts-api'),
  meetbot: base(process.env.REACT_APP_MEETBOT_API_URL, '/meetbot-api'),
  history: base(process.env.REACT_APP_HISTORY_API_URL, '/history-api'),
};

export default ENDPOINTS;
